import { FormError } from "../../models/FormValidation/FormError";
import { FormFieldMeta } from "../../models/FormValidation/FormFieldMeta";
import { FormValidity } from "../../models/FormValidation/FormValidity";
import { ProcurementCategorySummary, ProcurementSubcategorySummary } from "../../models/Master/ProcurementCategorySummary";
import { Util } from "../Util";

const validateData = (validateFieldsData: Array<FormFieldMeta>, dataToUpdate: any): FormValidity => {
  //setFormErrors([]);
  let valid = true;
  var tempArray: Array<FormError> = [];
  var result: FormValidity = {
    isValid: valid,
    errorsList: []
  };
  let len = validateFieldsData.length;
  //check rquired
  for (let index = 0; index < len; index++) {
    var fieldData = validateFieldsData[index];

    if (fieldData.isRequired) {
      if (
        !dataToUpdate[fieldData.fieldName] ||
        (fieldData.isList && dataToUpdate[fieldData.fieldName].length === 0)
      ) {
        tempArray.push({
          fieldName: fieldData.fieldName,
          errorMsg: fieldData.reuiredMsg!,
        });
        valid = false;
      }
    }
  }
  //check format issues- add 
  ///setFormErrors(tempArray);
  //return valid;
  result.isValid = valid;
  result.errorsList = tempArray;
  return result;
};

const getErrorState = (input: string, formErrors: Array<FormError>) => {
  var errIndex = formErrors.findIndex(function (row) {
    return row.fieldName === input && row.errorMsg;
  });
  return errIndex !== -1 ? true : false;
};

const getProcurementCategories = (procurementCatList: ProcurementSubcategorySummary[]): ProcurementCategorySummary[] => {
  let procurementCats: ProcurementCategorySummary[] = [];
  procurementCatList.forEach(p => {
    if (!procurementCats.find(e => e.procurmentCategoryId == p.procurmentCategoryId)) {
      procurementCats.push({
        vendorCategoryId: p.vendorCategoryId,
        procurmentCategoryId: p.procurmentCategoryId,
        procurmentCategoryName: p.procurmentCategoryName
      });
    }
  });
  return Util.sortObjByString(procurementCats, "procurmentCategoryName") as ProcurementCategorySummary[];
};

const getNameFromProcSubCategorName = (procSubFullName: string): string => {
  return procSubFullName.substring(0, procSubFullName.indexOf('('));
};

const getSpendMngByFromProcSubCategorName = (procSubFullName: string): string => {
  return procSubFullName.substring(procSubFullName.indexOf('(') + 1, procSubFullName.indexOf(')'));
};

const getSpendMngByFromProcSubCategorId = (procSubs: ProcurementSubcategorySummary[], procSubId: number): string => {
  const procSub = procSubs.find(p => p.procurmentSubcategoryId === procSubId);
  if (procSub) {
    return procSub.procurmentSubcategoryName.substring(procSub.procurmentSubcategoryName.indexOf('(') + 1
      , procSub.procurmentSubcategoryName.indexOf(')'));
  }
  return '';
};

export const MasterDataUtil = {
  validateData,
  getErrorState,
  getProcurementCategories,
  getNameFromProcSubCategorName,
  getSpendMngByFromProcSubCategorName,
  getSpendMngByFromProcSubCategorId
};
